export default {
  play: '今すぐプレイ',
  fullscreen: '全画面モード',
  addToFavorites: 'お気に入りに追加',
  removeFromFavorites: 'お気に入りから削除',
  similarGames: '類似ゲーム',
  howToPlay: '遊び方',
  gameDescription: 'ゲーム説明',
  controlsAndInstructions: '操作と説明',
  share: '共有',
  gameUnavailable: 'ゲームは利用できません',
  tryAgainLater: 'このゲームは現在利用できません。後でもう一度お試しください。',
  openInNewTab: '新しいタブで開く',
  gameTitle: 'ゲームタイトル',
  genres: 'ゲームジャンル',
  tags: 'タグ',
  noGenre: 'ジャンルなし',
  noTags: 'タグなし',
  new: '新着ゲーム',
  playAmazingGame: 'この素晴らしいゲームを今すぐプレイ！',
  noSimilarGames: '類似ゲームはありません',
  gameNotFound: 'ゲームが見つかりません',
  gameNotExistOrRemoved: 'お探しのゲームは存在しないか削除されました。',
  backToHome: 'ホームに戻る',
  seoTitle: '{title} - オンラインプレイ - GoGameVault',
  seoTitleNotFound: 'ゲームが見つかりません - GoGameVault',
  seoKeywords: '{title}をプレイ, 無料オンラインゲーム, {tags}ゲーム',
  gameFeatures: 'ゲームの特徴',
  controlDetails: '操作の詳細'
}; 